(function () {
  const CONTAINER_SELECTOR =
    ".shopify-app-block .bss-po-option-set [id^='po_container--']";

  function parseHeading(text) {
    // Supports: "Step 2 - Choose finial style" or "STEP 2: Choose..."
    const m = text.match(/^\s*step\s*(\d+)\s*[-:–]\s*(.+)\s*$/i);
    if (!m) return null;
    return { step: m[1], title: m[2] };
  }

  function convertHeadings(container) {
    // Find elements that look like your OPTIS "Heading" blocks.
    // We detect by text that starts with "Step X - ..."
    const all = Array.from(container.querySelectorAll("*"))
      .filter((el) => el.children.length === 0) // leaf nodes (text-only-ish)
      .filter((el) => el.textContent && /step\s*\d+\s*[-:–]/i.test(el.textContent));

    all.forEach((el) => {
      if (el.closest(".step-header")) return;

      const raw = el.textContent.trim();
      const parsed = parseHeading(raw);
      if (!parsed) return;

      // Prevent double conversion
      if (el.dataset.stepConverted === "1") return;

      // Replace the heading text with your styled header
      const header = document.createElement("div");
      header.className = "step-header";
header.innerHTML = `
  <div class="step-badge">Step ${parsed.step}</div>
  <div class="step-title">${parsed.title}</div>
`;

      // Put header where the heading text was
      el.textContent = "";
      el.appendChild(header);
      el.dataset.stepConverted = "1";
    });
  }

  function boot() {
    const container = document.querySelector(CONTAINER_SELECTOR);
    if (!container) return false;

    convertHeadings(container);

    const obs = new MutationObserver(() => convertHeadings(container));
    obs.observe(container, { childList: true, subtree: true });

    return true;
  }

  if (boot()) return;

  const pageObs = new MutationObserver(() => {
    if (boot()) pageObs.disconnect();
  });
  pageObs.observe(document.documentElement, { childList: true, subtree: true });
})();